<div class="wrapper"
  #container
  (tunResize)="onResizeContainer($event)"
  >

  <div class="imageWrapper">
    <img class="backgroundImage" [src]="imageUrl$ | async">
    <div class="gradientLayer"></div>
  </div>

  <div class="contentWrapper">

    <div class="title">{{'home.continuePlay.label.title' | translate }}</div>
    <hr class="horizontalLine purple-line"/>

    <div class="content-container">

      @if ((lastPlayedItemsLoading$ | async)) {
        <div class="loaderContainer">
          <mat-spinner class="loading-spinner"></mat-spinner>
          <span class="loadingText">{{'general.status.loading' | translate}}</span>
        </div>
      }

      @if ((lastPlayedItemsLoadingError$ | async)) {
        <div class="errorContainer">
          <p>{{'general.status.error.message' | translate}}</p>
          <button (click)="onRetryLastPlayed()" class="retryButton">
            <p>
              {{'general.status.error.retry' | translate }}
            </p>
          </button>
        </div>
      }

      @if (showNoLastPlayedItems$ | async) {
        <div class="noItemsContainer">
          <div class="noItemTitle" translate>home.continuePlay.noContent.title</div>
          <div class="noItemText" translate>home.continuePlay.noContent.text</div>
        </div>
      }

      @if ((showLastPlayedItems$ | async)) {
        <div class="itemContainer {{ gridClassName }}">
          @for (lastPlayedItem of (lastPlayedItems$ | async); track lastPlayedItem; let i = $index) {
            @if (isMusicChannel(lastPlayedItem)) {
              <tun-music-channel-view
                class="item"
                [imageHolder]="lastPlayedItem.matchedItem"
                playButtonShowStragegy="ALWAYS"
                (showDetails)="onShowDetailsForMusicChannel($event)">
              </tun-music-channel-view>
            }
            @if (isCalendar(lastPlayedItem)) {
              <tun-calendar-view
                class="item"
                [imageHolder]="lastPlayedItem.matchedItem"
                playButtonShowStragegy="ALWAYS"
                (showDetails)="onShowDetailsForCalendar($event)">
              </tun-calendar-view>
            }
            @if (!isMusicChannel(lastPlayedItem) && !isCalendar(lastPlayedItem)) {
              <div
                class="item emptyItem"
                >
              </div>
            }
          }
        </div>
      }

    </div>




    <div class="title">
      <tun-ai-stars-v5 class="icon icon-scaled-svg-button ai-icon"></tun-ai-stars-v5>
      {{'home.recommendations.label.title' | translate }}
      <div class="ai-box">AI</div>
    </div>
    <hr class="horizontalLine green-line"/>
    <div class="content-container">

      @if ((recommendationsLoading$ | async)) {
        <div class="loaderContainer">
          <mat-spinner class="loading-spinner"></mat-spinner>
          <span class="loadingText">{{'general.status.loading' | translate}}</span>
        </div>
      }

      @if ((recommendationsLoadingError$ | async)) {
        <div class="errorContainer">
          <p>{{'general.status.error.message' | translate}}</p>
          <button (click)="onRetryRecommendations()" class="retryButton">
            <p>
              {{'general.status.error.retry' | translate }}
            </p>
          </button>
        </div>
      }

      @if (showNoRecommendations$ | async) {
        <div class="noItemsContainer">
          <div class="noItemTitle" translate>home.recommendations.noContent.title</div>
          <div class="noItemText" translate>home.recommendations.noContent.text</div>
        </div>
      }


      @if ((showRecommendations$ | async)) {
        <div class="itemContainer {{ gridClassName }}">
          @for (recommendedMusicChannel of (recommendedMusicChannels$ | async); track recommendedMusicChannel; let i = $index) {
            <tun-music-channel-view
              class="item"
              [imageHolder]="recommendedMusicChannel.musicChannel"
              [recommendationsAmount]="recommendedMusicChannel.musicCollections.length"
              (showDetails)="onShowDetailsForMusicChannel($event)">
            </tun-music-channel-view>
          }
        </div>
      }
    </div>

  </div>



</div>
